import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import i, { popoverBaseProps as n } from "../../popover/src/Popover.js";
import m from "../../_mixins/use-config.js";
import s from "../../_mixins/use-theme.js";
import l from "../styles/light.js";
import { defineComponent as a, computed as c, h } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as d } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const f = Object.assign(Object.assign({}, n), s.props), x = a({
  name: "Tooltip",
  props: f,
  slots: Object,
  __popover__: !0,
  setup(e) {
    const {
      mergedClsPrefixRef: o
    } = m(e), r = s("Tooltip", "-tooltip", void 0, l, e, o), t = d(null);
    return Object.assign(Object.assign({}, {
      syncPosition() {
        t.value.syncPosition();
      },
      setShow(p) {
        t.value.setShow(p);
      }
    }), {
      popoverRef: t,
      mergedTheme: r,
      popoverThemeOverrides: c(() => r.value.self)
    });
  },
  render() {
    const {
      mergedTheme: e,
      internalExtraClass: o
    } = this;
    return h(i, Object.assign(Object.assign({}, this.$props), {
      theme: e.peers.Popover,
      themeOverrides: e.peerOverrides.Popover,
      builtinThemeOverrides: this.popoverThemeOverrides,
      internalExtraClass: o.concat("tooltip"),
      ref: "popoverRef"
    }), this.$slots);
  }
});
export {
  x as default,
  f as tooltipProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tooltip/src/Tooltip.js
// module id = 495
// module chunks = 67